// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileCard_container__2jj-f","avatar":"ProfileCard_avatar__16i4N","info":"ProfileCard_info__3L0Ss","title":"ProfileCard_title__3AFeS"};